// Copyright (c) 2015 Steven Sojka
import { ApplicateOptions, Applicator } from './Applicator';

export class BindApplicator extends Applicator {
  apply({ value, config: { execute }, args, instance, target }: ApplicateOptions): any {
    if (!instance) {
      return value;
    }

    return execute(value, instance, ...args);
  }
}
